export default "__VITE_ASSET__CO$uOck5__"